var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const claim = namespace('claim');
let OpenSelfcareButton = class OpenSelfcareButton extends Vue {
    openSelfcare() {
        if (!this.canEdit)
            return;
        if (this.magicLink)
            window.open(this.magicLink, '_blank');
    }
};
__decorate([
    Prop({ type: Boolean, default: true })
], OpenSelfcareButton.prototype, "canEdit", void 0);
__decorate([
    claim.State('magicLink')
], OpenSelfcareButton.prototype, "magicLink", void 0);
OpenSelfcareButton = __decorate([
    Component
], OpenSelfcareButton);
export default OpenSelfcareButton;
